<cm-overlay
  [width]="1150"
  [height]="640"
  header="{{ 'PROFILE_ACCOUNT_DETAIL_TITLE' | translate }}"
>
  <app-account-detail-card
    [resident]="resident$ | async"
  ></app-account-detail-card>
</cm-overlay>
